export default __webpack_public_path__ + "static/media/emailGrey.432c7125.svg";